<div class="card card-user">
  <div class="card-header">
    <h4 class="card-title">Subscriptions</h4>
  </div>
  <div class="card-body">
    <app-subscription [isSaving]="isSaving" (subscriptionAdded)="onSubscriptionAdded($event)" [currentProject]="currentProject" [currentApiId]="currentApiId"></app-subscription>
    
    <div class="row" *ngIf="currentProject.apiKey && currentConfiguration">
      <div class="col">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <img style="height: 32px;" class="mb-1" src="../../../assets/images/logo-small.png"/>
            <a class="nav-link active" href="#">Prometheus</a>
          </li>
          <li class="nav-item">
            <img style="height: 32px;" class="mb-1" src="../../../assets/images/ftp-server-logo.png"/>
            <a class="nav-link" href="#">FTP Site</a>
          </li>
          <li class="nav-item">
            <img style="height: 32px;" class="mb-1" src="../../../assets/images/Google_Drive_logo.png"/>
            <a class="nav-link" href="#">Google Drive</a>
          </li>
          <li class="nav-item">
            <img style="height: 32px;" class="mb-1" src="../../../assets/images/Dropbox_Logo2.png"/>
            <a class="nav-link disabled" href="#">Dropbox</a>
          </li>
        </ul>            
      </div>
    </div>

    <div class="row mt-3" *ngIf="currentProject.apiKey && currentConfiguration">
      <div class="col text-right">
        <button type="button" (click)="onSave()" class="btn btn-primary">Save</button>
      </div>
    </div>

    <div class="row mt-3" *ngIf="currentProject.apiKey && currentConfiguration">
      <div class="col">
        <form>
          <div class="form-row">
            <div class="form-group col">
              <label for="prefix">Name</label>
              <input type="text" [(ngModel)]="currentConfiguration.name" name="ConfigName" class="form-control" id="ConfigName">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col">
              <label for="prefix">Prefix</label>
              <input type="text" class="form-control" id="prefix">
            </div>
            <div class="form-group col">
              <label for="subfix">Subfix</label>
              <input type="text" class="form-control" id="subfix">
            </div>
            <div class="form-group col">
              <label for="extensions">Allowed Extensions (,)</label>
              <input type="text" class="form-control" id="extensions">
            </div>
            <div class="form-group col">
              <label for="extensions">Dimensions (Height x With)</label>
              <input type="text" class="form-control" id="dimensions">
            </div>
          </div>
        </form>
        <hr/>

      </div>
    </div>

    <div class="row mt-3" *ngIf="currentProject.apiKey && currentConfiguration">
      <div class="col-4">
        <div class="row">
          <div class="col">
            <input type="text" [(ngModel)]="currentLocationName" name="locationName" class="form-control" id="inlineFormInput" placeholder="">
          </div>
          <div class="col-auto">
            <button type="button" (click)="onAddLocation()" class="btn btn-sm btn-primary m-0">Add</button>
          </div>     
        </div>
        <div class="row mt-3">
          <div class="col">
            <ul class="contentLocations">
              <li *ngFor="let loc of currentConfiguration.contentLocations"
                [class.selected]="loc === selectedLocation"
                (click)="onContentLocation(loc)">
                <span class="badge">{{loc.id}}</span> <span class="contentLocationName">{{loc.name}}</span>
              </li>
            </ul>
          </div>          
        </div>
      </div>


      <div class="col-8">
          <div class="table-responsive">
            <table class="table">
              <thead class=" text-primary">
                <tr><th>
                  Document Name
                </th>
                <th class="text-right">
                  ...
                </th>
              </tr></thead>
              <tbody>
                <tr *ngFor="let d of docsCollection">
                  <td>
                    {{d.name}}
                  </td>
                  <td class="text-right">
                    <a href="{{d.url}}" target="_blank">
                      <i class="fa fa-download" aria-hidden="true"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>          
      </div>
    </div>
  </div>
</div>
